import {useState, useEffect, useRef, useCallback} from "react";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {inject, observer} from "mobx-react";
import {
    ErrorMessage,
    NotiStackInfo
} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import Results from "../../../../palette/Results";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {FormContainer, Layout} from "../../../../palette/Palette";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {db} from "../../../../firebase/Firebase";
import Alerts from "../../../../palette/Alerts";
import {transaction} from "mobx";


const display = [{ID: 1, type: 'Tipo de vehículo'}, {ID: 2, type: 'Orden'}]

const data = {
    providerPercentage: null,
    cardPayment: false,
    tripStartControl: 60,
    paymentGatewayCommission: null,
    transaction: null,
    IVA: null,
    maximumTimeReservation: null,
    maximumCancellationTime: null,
    vehicleDisplay: ''
}

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function GeneralValues(props) {

    const {DataStore} = props
    const {companyName, idCompany, finished, generalValues} = DataStore

    const [submitButton, setSubmitButton] = useState({...buttonSuccess, text: 'Guardar valores'})
    const [load, setLoad] = useState(true)
    const [result, setResult] = useState(null)
    const [checkBoxValue, setCheckboxValue] = useState(data.cardPayment)
    const [dataValues, setDataValues] = useState(generalValues)
    const [dataSource, setDataSource] = useState(generalValues)
    const [trigger, setTrigger] = useState(false)
    const [textLoad, setTextLoad] = useState('Cargando...')

    const isMounted = useMountedState()

    useEffect(() => {
        setDataSource(generalValues)
        setDataValues(generalValues)
    }, [generalValues])

    /*  useEffect(() => {
          const GeneralValues = async () => {
              const docRef = db.collection(companyName).doc(idCompany).collection('GeneralValues')
              setLoad(false)
              await docRef.doc(idCompany).get()
                  .then(doc => {
                      if (doc.exists) {
                          setDataValues(doc.data())
                          setSubmitButton({
                              ...buttonSuccess, text: 'Actualizar valores', icon: 'far fa-edit'
                          })
                          doc.data().cardPayment ? setCheckboxValue(true) : setCheckboxValue(false)
                          setLoad(true)
                      } else {
                          setDataValues({...data})
                          setLoad(true)
                      }
                  })
          }

          if (isMounted()) {
              GeneralValues().catch(() => {
                  //setTrigger(!trigger)
              })
          }

      }, [companyName, idCompany, isMounted, trigger])*/

    const {enqueueSnackbar} = useSnackbar();

    const alertsRender = () => {
        return (
            <Results results={result} text={'Los datos han sido guardados exitosamente'}/>
        )
    }

    const onValueChanged = (key, value) => {
        if (value !== undefined && Object.entries(dataValues).length > 0) {
            setDataValues({...dataValues, [key]: value})
            setCheckboxValue(value)
        }
    }

    const handleSubmit = async (e) => {

        e.preventDefault()

        const text = submitButton.text === 'Actualizar valores' ? 'Actualizando...' : 'Guardando...'

        setSubmitButton({...submitButton, disabled: true, text: text})
        setLoad(false)
        setTextLoad(text)

        const newObj = {
            ...dataSource, IVA: dataValues.IVA, cardPayment: dataValues.cardPayment,
            paymentGatewayCommission: dataValues.paymentGatewayCommission, transaction: dataValues.transaction,
        }

        const docRef = db.collection(companyName).doc(idCompany).collection('GeneralValues')

        await docRef.doc(idCompany)
            .set(newObj).then(async () => {
                setResult('OK')
                setTimeout(() => {
                    setResult(null)
                }, 2000)
                setLoad(true)
                setSubmitButton({...submitButton, icon: 'far fa-edit', disabled: false, text: 'Actualizar valores'})
                await DataStore.GeneralValues(companyName, idCompany)
                DataStore.getGeneralValues(newObj.providerPercentage, newObj.tripStartControl,
                    newObj.maximumTimeReservation, newObj.vehicleDisplay);
            }).catch(async () => {
                setResult('OK')
                setTextLoad('Cargando..')
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                await DataStore.GeneralValues(companyName, idCompany)
            })
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="crete-users-container">
                <HeaderPage icon={'fas fa-receipt'} text={'Valores generales'} load={load}
                            textLoad={textLoad}/>
                {finished ?
                    <FormContainer>
                        <form action="" onSubmit={handleSubmit}>
                            <Form
                                formData={dataSource}
                                readOnly={false}
                                showColonAfterLabel={true}
                                validationGroup="generalValues"
                            >
                                <GroupItem caption="Configuración de valores generales" colCount={1}>
                                    <SimpleItem dataField="providerPercentage"
                                                label={{text: '% De comisión del proveedor'}}
                                                editorType={'dxNumberBox'}
                                                editorOptions={{format: "#0%", maxLength: 2, min: 0, max: 1}}>
                                        <RequiredRule message="Ingrese el procentaje."/>
                                    </SimpleItem>

                                    <SimpleItem label={{text: 'Pagos con tarjeta de crédito'}}
                                                editorType="dxCheckBox"
                                                dataField="cardPayment"
                                                editorOptions={{
                                                    value: generalValues?.cardPayment,
                                                    onValueChanged: (e) => onValueChanged('cardPayment', e.value)
                                                }}/>
                                </GroupItem>


                                {generalValues?.cardPayment && <GroupItem colCount={2}>
                                    <SimpleItem dataField="paymentGatewayCommission"
                                                label={{text: '% De comisión de la pasarela de pagos'}}
                                                editorType={'dxNumberBox'}
                                                editorOptions={{format: "#0%", maxLength: 2, min: 0, max: 1}}>
                                        <RequiredRule message="Ingrese el procentaje."/>
                                    </SimpleItem>
                                    <SimpleItem dataField="transaction"
                                                editorOptions={{format: "$ #.##"}}
                                                label={{text: 'Costo por transacción '}}
                                                editorType={'dxNumberBox'}>
                                        <RequiredRule message="Ingrese el costo por transacción."/>
                                    </SimpleItem>
                                    <SimpleItem label={{text: 'IVA'}} value={dataValues.IVA} dataField="IVA"
                                                editorType="dxCheckBox"/>

                                </GroupItem>}

                                <GroupItem colCount={1}>

                                    <SimpleItem dataField="tripStartControl"
                                                label={{text: 'Tiempo antes de iniciar un viaje (min)'}}
                                                editorOptions={{defaultValue: 60}}
                                                editorType={'dxNumberBox'}
                                    >
                                        <RequiredRule message="Ingrese tiempo antes de iniciar un viaje."/>
                                    </SimpleItem>

                                    <SimpleItem dataField="maximumTimeReservation"
                                                label={{text: 'Tiempo de anticipación a una reserva (min)'}}
                                                editorType={'dxNumberBox'}
                                                editorOptions={{
                                                    placeholder: 'Recomendable mayor a 120 minutos',
                                                    maxLength: 3
                                                }}>
                                        <RequiredRule message="Ingrese el tiempo de anticipacio."/>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="maximumCancellationTime"
                                                label={{text: 'Máximo tiempo de cancelación (min)'}}
                                                editorType={'dxNumberBox'}
                                                editorOptions={{maxLength: 3}}>

                                        <RequiredRule message="Ingrese el tiempo máximo decancelación."/>
                                    </SimpleItem>

                                    <SimpleItem dataField="vehicleDisplay" label={{text: 'Visualización de vehículos'}}
                                                editorType="dxSelectBox"
                                                editorOptions={{
                                                    dataSource: display,
                                                    displayExpr: "type",
                                                    valueExpr: "type",
                                                    searchEnabled: true,
                                                    placeholder: 'Seleccionar...'
                                                }}>
                                        <RequiredRule message="Seleccione el tipo visualización"/>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={1}>
                                    {result && <SimpleItem render={alertsRender}/>}
                                </GroupItem>

                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>

                            </Form>
                        </form>
                    </FormContainer> :
                    <Layout>
                        <VerticalSpace space={25}/>
                        <Alerts severity={'error'}
                                body={'¡No se han terminado de configurar los datos de la empresa!'}/>
                    </Layout>}
            </div>
        </>
    )
}

export default inject('DataStore')(observer(GeneralValues));
